import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { WalletProvider } from './providers/WalletProvider';
import { QueryProvider } from './providers/QueryProvider';
import { ThemeProvider } from './providers/ThemeProvider';

function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <WalletProvider>
          <RouterProvider router={router} />
        </WalletProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}

export default App;
